module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAjElEQVQ4T2NkoBAwUqifAW7A8ePH/RgYGGYyMDBIEDD0BQMDQ7qlpeUmkDpkA54rK6tJcHHz4NX/7esXhrt3b72wtLSURDfgv66eEVE+unzpHIOlpSXYcmQXjBpw/PgwCAOiEtLXr18Y7mFLSCdOnPD/////DGKSMiMjY4aFhcVGlIREVBLEooji3AgAFrtdEclYLxkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pop_btn_xy_nor.png
// module id = x7W3
// module chunks = 1